var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sj-procedure"},[_vm._t("default",null,null,{ step: _vm.step, status: _vm.status })],2)}
var staticRenderFns = []

export { render, staticRenderFns }